var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatForum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 7.5H30.25V21.5C30.25 22.4625 29.4625 23.25 28.5 23.25H7.5V25C7.5 26.925 9.075 28.5 11 28.5H28.5L35.5 35.5V11C35.5 9.075 33.925 7.5 32 7.5ZM26.75 16.25V4C26.75 2.075 25.175 0.5 23.25 0.5H4C2.075 0.5 0.5 2.075 0.5 4V26.75L7.5 19.75H23.25C25.175 19.75 26.75 18.175 26.75 16.25Z",
    fill: "#498CCE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatForum);
export default __webpack_public_path__ + "static/media/chat_forum.5d89a3e76f668f7ff9dca6b643ae6e3b.svg";
export { ForwardRef as ReactComponent };